import { useContext } from 'react';
import { ConfirmDialogContext } from '../contexts/ConfirmDialogContext';

const useConfirmDialog = () => useContext(ConfirmDialogContext);

export default useConfirmDialog